<template>
  <div class="appbars" ref="appbars">
    <div @mouseenter="outSelectItem"  class='homeactives'  style="width:200px;text-align: center;">
      <a href="javascript:window.open('/','_self');">浏览产品分类</a>
      <div class="pull-down" style="color:#000">
        <div @mouseenter="selectItem(index)" :class="{'active':selectNumber === index}"
             class="pull_item"
             v-for="(item,index) in category" :key="item.tree_id">
          {{ item.tree_alias == '' ? item.tree_name : item.tree_alias }}
        </div>
        <div class="pull-right">
          <div class="pull_list clearfix" v-for="item in subCategory" :key="item.tree_id">
            <label style="color:#0066BA;font-size:14px;cursor: pointer;line-height:20px" @click="toCategory(item.tree_id)">{{ item.tree_name }}</label>
            <div style="margin-top:6px">
              <span @click="toCategory(items.tree_id)"
                v-for="items in item.sub_category"
                :key="items.tree_id">{{ items.tree_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appbar" ref="appbar">
        <div :class="routepath == '/' ? 'homeactive' : ''">
          <a href="javascript:window.open('/','_self');">首页</a>
        </div> 
        <div :class="routepath == '/coBrands' ? 'homeactive' : ''">
          <a href="javascript:window.open('/coBrands','_self');">合作品牌</a>
        </div>
        <div :class="routepath == '/productLineList' || routepath == '/productLineDetail' ? 'homeactive' : ''">
          <a href="javascript:window.open('/productLineList','_self');">优势产品线</a>
        </div>    
        <div :class="routepath == '/promotionProductList' ? 'homeactive' : ''">
          <a href="javascript:window.open('/promotionProductList','_self');">促销活动</a>
        </div>    
        <div :class="routepath == '/advsearch' ? 'homeactive' : ''">
          <a href="javascript:window.open('/advsearch','_self');">高级搜索</a>
        </div>
        <div :class="routepath == '/pointsMall' || routepath == '/pointsDetail' ? 'homeactive' : 'jfsc'">
          <a  href="javascript:window.open('/pointsMall','_self');">积分商城</a>
        </div>
        <div :class="routepath == '/profileInfo' ||  routepath == '/order_history' ||  routepath == '/prepay' ||  routepath == '/profilePassword'  ||  routepath == '/profileAddress' ||  routepath == '/credit'||  routepath == '/coupon' ? 'homeactive' : ''">
          <a href="javascript:window.open('/profileInfo','_self');">我的账户</a>
        </div>
    </div>
  
  </div>
</template>

<script setup>
import { ref, watch, onMounted  } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import api from '@/axios/api'
const router = useRouter()
const route = useRoute()
// 定义 props
const props = defineProps({
  categoryData: {
    type: Array,
    default: () => []
  }
});
const routepath = ref('/')
// 定义响应式数据
const appbar = ref(null);
const category = ref(null);
const subCategory = ref(null);
const selectNumber = ref('');

// 处理"浏览全部产品分类"下的数据开始
// 处理下拉款数据
const selectItem = (index) => {
  subCategory.value = category.value[index].sub_category;
  selectNumber.value = index;
};

// 处理下拉框鼠标悬停、离开样式
const outSelectItem = () => {
  selectNumber.value = '';
};
// 处理"浏览全部产品分类"下的数据结束

// 处理产品类别点击开始
const toCategory = (treeId) => {
  const url = `/classify/${treeId}`
  window.open(url, '_blank')
};
// 处理产品类别点击结束

// 监听 categoryData 的变化
watch(() => route.path, () => {
  // if(route.path !== '/'){
    api.goods.homeclassifyApi().then((res)=>{
      if(res.data.code === 200){
        category.value = res.data.data.category_nav_tree
      }
    })
  // }else{
  //   category.value = []
  // }
  routepath.value = route.path
})

onMounted(() => {
  // if(route.path !== '/'){
    api.goods.homeclassifyApi().then((res)=>{
      if(res.data.code === 200){
        category.value = res.data.data.category_nav_tree
      }
    })
  // }else{
  //   category.value = []
  // }
})
</script>

<style scoped>

.homeactives{
  /* background: #0066BA; */
  position: relative;
  display: inline-block;
  padding:10px 0px;
  /* padding:0px 55px; */
    /* padding: 10px 30px; */
}

.homeactives::before {
  content: '';
  position: absolute;
  top: 0px; /* 上移3px覆盖.appbar的border */
  left: 0;
  right: -5px; /* 右侧延伸3px */
  bottom: 0;
  /* background: #0066BA; */
  background: linear-gradient(100deg, #0066BA, #0096CC);
  border-top:5px solid #FFD700;
  border-right:7px solid #FFD700;
  border-top-left-radius: 10px;
  border-top-right-radius: 19px;
  /* 使用clip-path实现倾斜圆角 */
  clip-path: polygon(
    -8px 0, calc(100% - 8px) 0, 100% -8px, 
    100% 100%, 0 100%, 0 8px
  );
  transform: skewX(-15deg);
  z-index: -1;
}

.homeactive{
  font-weight: 600;
}

a {
  text-decoration: none;
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.appbars {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  font-size: 15px;
  /* line-height: 34px; */
  color: #636363;
  /* position: relative; */
  display: flex;
  justify-content: space-between;
  
}

.appbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom:5px;
  width:1000px;
  border-bottom:4px solid #FFD700;
  padding-left:50px
}


.appbars > div a {
  color: #302d2d;
}

.appbars .homeactives a {
  color: #fff !important; 
}

.appbars .homeactive a {
  /* color: #e5a43e !important;  */
  color: #0066BA !important;
}

/* .appbars > div a:hover {
  text-decoration: underline;
} */

.appbars .pull-down {
  width: 200px;
  position: absolute;
  /* border: 1px solid #dddddd; */
  top:42px;
  z-index: 99999;
  border-radius: 0 0 8px 8px;
  background: #ffffff;
  display: none;  
  box-shadow: 0 10px 15px -5px rgba(0,0,0,0.2)
}

.appbars .pull-down .pull_item {
  font-size: 12px;
  /* border-bottom: 1px solid #dddddd; */
  cursor: default;
  /* padding-left: 12px; */
  width: 180px;
  line-height: 30px;
  margin: auto;
}

.appbars .pull-right {
  width: 900px;
  min-height: 400px;
  max-height: 800px;
  position: absolute;
  overflow-y: auto;
  left: 201px;
  top: 0;
  border: 1px solid #0066BA;
  background: #ffffff;
  z-index: 9999;
  display: none;
  padding:10px 20px
}

.appbars .pull-right .pull_list {
  line-height: 10px;
  padding: 10px 0;
  font-size: 12px;
  color: #666666;
  display: flex;
}

.appbars .pull-right .pull_list label {
  font-weight: bold;
  width: 130px;
  text-align: right;
  padding-right: 10px;
  float: left;
  font-size: 13px;
}

.appbars .pull-right .pull_list span {
  display: inline-block;
  padding: 0 10px;
  margin-bottom: 10px;
  /* border-left: 1px solid #dddddd; */
  cursor: pointer;
  font-size: 13px;
}

.appbars .pull-right .pull_list span:hover {
  /* text-decoration: underline; */
  color: rgb(0, 117, 199);
}

.appbars .pull-right .pull_list > div {
  margin-top:3px;
  flex:1;
  display: flex;
  flex-wrap: wrap;
}

.appbars > div:nth-child(1):hover .pull-down {
  z-index: 999;
  display: block;
}

.appbars .pull-down:hover .pull-right {
  display: block;
}

.appbars .pull-down .active {
  background: #EBEEF5;
  color: #000;
  border-radius: 5px;
  cursor: pointer;
}

.jfsc a{
  color: rgb(229, 164, 62) !important
}
</style>
